<template>
	<div>
		<!-- 面包屑导航区域 -->
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div class="search-area">
				<el-form ref="searchForm" :model="searchForm" label-width="70px" inline size="small">
					<el-form-item label="角色名称:">
						<el-input :clearable="true" v-model="searchForm.roleName" placeholder="请输入角色名称" style="width: 150px;" />
					</el-form-item>
					<el-form-item label="角色编码:">
						<el-input :clearable="true" v-model="searchForm.roleCode" placeholder="请输入角色编码" style="width: 150px;" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getRoleList()">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="addRoleInit()">+ 添加角色</el-button>
					</el-form-item>
				</el-form>
			</div>

			<!-- 角色列表区 -->
			<el-table :data="roleList" style="width: 100%;margin-top: 20px;" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}"
			 border :stripe="true" :highlight-current-row="true">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column prop="roleName" label="角色名称" sortable>
				</el-table-column>
				<el-table-column prop="roleCode" label="角色编码" sortable>
				</el-table-column>
				<el-table-column prop="description" label="角色描述">
				</el-table-column>
				<el-table-column prop="distributorName" label="运营商">
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="260" label="操作">
					<template slot-scope="scope">
						<el-button v-if="isSuperAuthority" size="mini" type="primary" icon="el-icon-edit" @click="updateRoleInit(scope.row)">编辑</el-button>
						<el-button size="mini" type="primary" icon="el-icon-setting" @click="assignPermission(scope.row)">分配权限</el-button>
						<el-button v-if="isSuperAuthority" size="mini" type="danger" icon="el-icon-delete" @click="deleteRole(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页区域 -->
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				style="margin-top: 20px; text-align: right;"
			></el-pagination>

			<!-- 添加角色 -->
			<el-dialog title="添加角色" :visible.sync="addRoleDialogVisible" width="600px">
				<!-- form表单 -->
				<el-form :model="roleForm" style="margin-right: 1.50rem;" status-icon :rules="roleRules" ref="roleForm"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="角色名称" prop="roleName">
						<el-input placeholder="请输入角色名称" v-model="roleForm.roleName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="角色编码" prop="roleCode">
						<el-input placeholder="请输入角色编码" v-model="roleForm.roleCode" size="small" :clearable=true @blur="checkRoleCode"></el-input>
						<el-alert v-if="codeError" :title="codeError" type="error" show-icon :closable=false style="margin-top: 10px;"></el-alert>
					</el-form-item>
					<el-form-item label="角色描述" prop="description">
						<el-input type="textarea" placeholder="请输入角色描述" v-model="roleForm.description" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addRoleDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addRole">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 角色修改 -->
			<el-dialog title="修改角色" :visible.sync="updateRoleDialogVisible" width="600px">
				<!-- form表单 -->
				<el-form :model="roleForm" style="margin-right: 1.50rem;" status-icon :rules="roleRules" ref="roleForm"
				 label-width="100px" class="demo-ruleForm">
					<el-form-item label="角色名称" prop="roleName">
						<el-input placeholder="请输入角色名称" v-model="roleForm.roleName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="角色编码" prop="roleCode">
						<el-input placeholder="请输入角色编码" v-model="roleForm.roleCode" size="small" :clearable=true @blur="checkRoleCode"></el-input>
						<el-alert v-if="codeError" :title="codeError" type="error" show-icon :closable=false style="margin-top: 10px;"></el-alert>
					</el-form-item>
					<el-form-item label="角色描述" prop="description">
						<el-input type="textarea" placeholder="请输入角色描述" v-model="roleForm.description" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateRoleDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateRole">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 分配权限 -->
			<el-dialog title="分配权限" :visible.sync="assignPermissionDialogVisible" width="600px">
				<div style="height: 400px;overflow: auto;padding: 10px;border: 1px solid #e8eaec;">
					<el-tree
						:data="authTree"
						ref="authTree"
						:check-strictly="true"
						:show-checkbox="true"
						node-key="id"
						:default-expand-all="true"
						:default-checked-keys="expandedKeys"
						:props="authProps"
						@check="handleAuthCheck"
					></el-tree>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="assignPermissionDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="savePermission">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentPage: 1,
				pageSize: 10,
				total: 0,
				searchForm: {
					roleName: '',
					roleCode: ''
				},
				roleForm: {},
				roleList: [],
				isSuperAuthority: false,
				authTree: [],
				expandedKeys: [],
				selectedRoleId: '',
				codeError: '',
				//控制添加用户信息对话框显示与隐藏
				addRoleDialogVisible: false,
				updateRoleDialogVisible: false,
				assignPermissionDialogVisible: false,
				roleRules: {
					//验证是否合法
					roleName: [{
							required: true,
							message: '请输角色名称',
							trigger: 'blur',
						},
						{
							min: 2,
							max: 100,
							message: '长度在 2 到 100 个字符',
							trigger: 'blur',
						}
					],
					roleCode: [{
							required: true,
							message: '请输角色编码',
							trigger: 'blur',
						},
						{
							min: 2,
							max: 100,
							message: '长度在 2 到 100 个字符',
							trigger: 'blur',
						}
					]
				},
				authProps: {
					children: 'children',
					label: 'name'
				}
			}
		},
		created() {
			this.initCurrentRoleCode()
			this.getRoleList()
		},
		methods: {
			initCurrentRoleCode() {
				const roleCodes = JSON.parse(window.sessionStorage.getItem('roleCodes') || '[]')
				const roles = JSON.parse(window.sessionStorage.getItem('roles') || '[]')
				this.isSuperAuthority = roleCodes.includes('SUPER_AUTHORITY') || roles.some(role => role.roleCode === 'SUPER_AUTHORITY')
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getRoleList()
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getRoleList()
			},
			async getRoleList() {
				const { data: res } = await this.$http.post('/api/permission/role/selectRolePageInfo', {
					page: this.currentPage,
					limit: this.pageSize,
					roleName: this.searchForm.roleName,
					roleCode: this.searchForm.roleCode
				})
				if (res.code != 200) return this.$message.error(res.msg)
				this.roleList = res.data.list
				this.total = res.data.total
			},
			addRoleInit() {
				this.addRoleDialogVisible = true
				this.roleForm = {}
				this.codeError = ''
			},
			async addRole() {
				this.$refs.roleForm.validate(async (valid) => {
					if (valid) {
						const { data: res } = await this.$http.post('/api/permission/role/saveOperateRole', this.roleForm)
						if (res.code == 200) {
							this.addRoleDialogVisible = false
							this.getRoleList()
							this.$message.success('添加成功')
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			async checkRoleCode() {
				if (!this.roleForm.roleCode) {
					this.codeError = ''
					return
				}
				const { data: res } = await this.$http.get('/api/permission/role/check-code', {
					params: {
						roleCode: this.roleForm.roleCode,
						id: this.roleForm.id
					}
				})
				if (res.code == 200) {
					if (res.data.exist) {
						this.codeError = '角色编码已存在'
					} else {
						this.codeError = ''
					}
				}
			},
			deleteRole(row) {
				this.$confirm("确认删除该角色吗？", {
					title: "提示",
					type: 'warning',
				}).then(async () => {
					const { data: res } = await this.$http.delete(`/api/permission/role/${row.id}`)
					if (res.code == 200) {
						this.getRoleList()
						this.$message.success('删除成功')
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			updateRoleInit(row) {
				this.roleForm = { ...row }
				this.updateRoleDialogVisible = true
				this.codeError = ''
			},
			async updateRole() {
				this.$refs.roleForm.validate(async (valid) => {
					if (valid) {
						const { data: res } = await this.$http.put('/api/permission/role', this.roleForm)
						if (res.code == 200) {
							this.getRoleList()
							this.updateRoleDialogVisible = false
							this.$message.success('修改成功')
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			async assignPermission(row) {
				this.selectedRoleId = row.id
				this.assignPermissionDialogVisible = true
				// 获取权限树
				const { data: authRes } = await this.$http.get(`/api/permission/auth-tree/${this.selectedRoleId}`)
				if (authRes.code == 200) {
					this.authTree = authRes.data
					// 收集所有已选中的权限ID
					this.expandedKeys = []
					this.collectCheckedKeys(this.authTree)
				}
			},
			collectCheckedKeys(tree) {
				tree.forEach(item => {
					if (item.checked) {
						this.expandedKeys.push(item.id)
					}
					if (item.children && item.children.length > 0) {
						this.collectCheckedKeys(item.children)
					}
				})
			},
			handleAuthCheck(currentObj, treeStatus) {
				// 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联
				let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1未选中
				// 选中
				if (selected !== -1) {
					// 子节点只要被选中父节点就被选中
					this.selectedParent(currentObj)
					// 统一处理子节点为相同的勾选状态
					this.uniteChildSame(currentObj, true)
				} else {
					// 未选中 处理子节点全部未选中
					if (currentObj.children) {
						this.uniteChildSame(currentObj, false)
					}
				}
			},
			uniteChildSame(treeList, isSelected) {
				this.$refs.authTree.setChecked(treeList.id, isSelected)
				if (treeList.children !== undefined) {
					for (let i = 0; i < treeList.children.length; i++) {
						this.uniteChildSame(treeList.children[i], isSelected)
					}
				}
			},
			// 统一处理父节点为选中
			selectedParent(currentObj) {
				let currentNode = this.$refs.authTree.getNode(currentObj)
				if (currentNode.parent.key !== undefined) {
					this.$refs.authTree.setChecked(currentNode.parent, true)
					this.selectedParent(currentNode.parent)
				}
			},
			async savePermission() {
				// 获取选中的权限ID
				const authIds = this.$refs.authTree.getCheckedKeys()
				
				// 保存权限
				const { data: res } = await this.$http.post('/api/permission/role-auth', {
					roleId: this.selectedRoleId,
					authIds
				})
				
				if (res.code == 200) {
					this.assignPermissionDialogVisible = false
					this.$message.success('权限分配成功')
				} else {
					this.$message.error('权限分配失败')
				}
			}
		},
	}
</script>

<style>
	.search-area {
		margin-bottom: 20px;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: #3CA757 !important;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: #3CA757 !important;
		background: #3CA757 !important;
	}
</style>